var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChefHatOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.72037,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "none",
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 25C21.2654 25 21.5197 24.8947 21.7073 24.7071C21.8948 24.5196 22.0001 24.2652 22.0001 24V18.65C22.0001 18.193 22.3161 17.806 22.7271 17.609C23.5781 17.2031 24.2583 16.5096 24.6478 15.6509C25.0372 14.7923 25.1108 13.8236 24.8556 12.916C24.6003 12.0083 24.0327 11.22 23.2528 10.6902C22.473 10.1603 21.531 9.92297 20.5931 10.02C20.2069 9.12224 19.566 8.35732 18.7497 7.81987C17.9334 7.28241 16.9775 6.99597 16.0001 6.99597C15.0228 6.99597 14.0669 7.28241 13.2506 7.81987C12.4343 8.35732 11.7934 9.12224 11.4071 10.02C10.4697 9.92365 9.52838 10.1613 8.74908 10.6912C7.96977 11.221 7.40255 12.009 7.14743 12.9161C6.8923 13.8233 6.96565 14.7914 7.35455 15.6498C7.74344 16.5082 8.42291 17.2017 9.27314 17.608C9.68414 17.806 10.0001 18.193 10.0001 18.649V24C10.0001 24.2652 10.1055 24.5196 10.293 24.7071C10.4806 24.8947 10.7349 25 11.0001 25H21.0001Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21H22",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefHatOutline);
export default __webpack_public_path__ + "static/media/chefHatOutline.fa64cf133a3800105a2a70d18cb81eb6.svg";
export { ForwardRef as ReactComponent };